import { Component, OnInit } from '@angular/core';
import { DatabaseService } from '../database.service';

@Component({
  selector: 'app-statisticmainblock',
  templateUrl: './statisticmainblock.component.html',
  styleUrls: ['./statisticmainblock.component.css']
})
export class StatisticmainblockComponent implements OnInit {


  NewCases:number=0;
  totalCasess:number=0;
  suspectedCases:number=0;
  nbgOfDeath:number=0;
  quarentaine:number=0;
  quarentaineAffected:number=0;
  restedHumans:number=0;

  serverIsFull:boolean=false;

  constructor(private database:DatabaseService) { }

  ngOnInit(): void {
    this.getMoreData();
    this.getNewCases();
  }

  getNewCases(){

      this.database.getNewInvections().subscribe((data)=>{
        this.NewCases=0;
        data.forEach(infect => {
          if (infect.data().stat==0) {
            this.NewCases++;
          }
        });
      });
  }



    getMoreData(){
    this.database.getMoreInformation().subscribe((data)=>{
      this.nbgOfDeath=data.data().nbrDeath;
      this.quarentaine=data.data().quarentaine;
      this.quarentaineAffected=data.data().quarentaineAffected;
      this.restedHumans=data.data().restedHumans;
      this.totalCasess=data.data().totalcases;
      
    },(error)=>{
      this.serverIsFull=true;
    });
  }

}
